import { createContext } from "react";
export const AuthContext = createContext(undefined);
//# sourceMappingURL=AuthContext.js.map